import { FileDown } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

import { Button } from "@/components/ui/button";
import { downloadPdf } from "@/lib/pdf";

import { ReceivablePdfDocument } from "./receivable-pdf-document";

import type { Receivable } from "@artisancode/api-types";

export function ReceivablePdfButton({
  receivable,
  variant = "outline",
  size = "sm",
}: {
  receivable: Receivable;
  variant?: "outline" | "ghost" | "link";
  size?: "sm" | "default";
}) {
  const [isGenerating, setIsGenerating] = useState(false);

  async function handleDownload() {
    setIsGenerating(true);
    try {
      await downloadPdf(
        <ReceivablePdfDocument receivable={receivable} />,
        `Tagihan-${receivable.customerName || "Pelanggan"}-${receivable.date}.pdf`,
      );
    } catch {
      toast.error("Gagal membuat PDF tagihan.");
    } finally {
      setIsGenerating(false);
    }
  }

  return (
    <Button
      type="button"
      variant={variant}
      size={size}
      onClick={handleDownload}
      disabled={isGenerating}
    >
      <FileDown className="mr-1.5 h-4 w-4" />
      {isGenerating ? "Membuat PDF..." : "Unduh PDF"}
    </Button>
  );
}
